import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "w-3/4 mx-auto" }, [
  /*#__PURE__*/_createVNode("p", { class: "text-xs text-center text-gray-500" }, " ※ 退室日時は学習時間の記録のために利用されます。生徒が退室していたはずの時間を入力してください。 ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 強制削除 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, { onClose: _ctx.close }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.student.data.name) + " の入室データの削除", 1)
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_m_text_field, {
          label: "退室日時",
          name: "date",
          type: "date",
          placeholder: "",
          value: _ctx.date,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.date = $event))
        }, null, 8, ["value"])
      ]),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_m_text_field, {
          label: "退室時間",
          name: "time",
          type: "time",
          placeholder: "",
          value: _ctx.time,
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.time = $event))
        }, null, 8, ["value"])
      ]),
      _hoisted_3
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_m_button, {
        color: "red-400",
        "hover-color": "red-500",
        disabled: !_ctx.validData,
        onClick: _ctx.deleteRegistrant
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
}